import ArrowBackIosNew from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { IconButton, IconButtonProps } from '@mui/material';

export enum ArrowNavButtonDirection {
  FORWARD,
  BACKWARD,
}

export interface ArrowNavButtonProps extends IconButtonProps {
  arrowNavButtonDirection: ArrowNavButtonDirection;
  titleAccess?: string;
}

const ArrowNavButton = ({ arrowNavButtonDirection, titleAccess, ...props }: ArrowNavButtonProps) => {
  return (
    <IconButton size="large" {...props}>
      {arrowNavButtonDirection === ArrowNavButtonDirection.BACKWARD ? (
        <ArrowBackIosNew titleAccess={titleAccess} />
      ) : (
        <ArrowForwardIos titleAccess={titleAccess} />
      )}
    </IconButton>
  );
};

export const ForwardButton = (props: Omit<ArrowNavButtonProps, 'arrowNavButtonDirection'>) => (
  <ArrowNavButton arrowNavButtonDirection={ArrowNavButtonDirection.FORWARD} {...props} />
);

export const BackButton = (props: Omit<ArrowNavButtonProps, 'arrowNavButtonDirection'>) => (
  <ArrowNavButton arrowNavButtonDirection={ArrowNavButtonDirection.BACKWARD} {...props} />
);
